import { IconAxisX } from "@tabler/icons-react"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import type { Accelerometer } from "@/types/device"

interface AccelerometerCardProps {
  data: Accelerometer | null
}

export function AccelerometerCard({ data }: AccelerometerCardProps) {
  return (
    <Card>
      <CardHeader className="pb-2">
        <div className="flex items-center gap-2">
          <IconAxisX className="size-4 text-cyan-500" />
          <CardDescription>Accelerometer</CardDescription>
        </div>
        <CardTitle className="text-lg">
          {data ? "Active" : "No data"}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-3 gap-4 text-center">
          <div>
            <p className="text-xs text-muted-foreground">X</p>
            <p className="text-lg font-medium tabular-nums">
              {data?.x ?? "--"}
            </p>
          </div>
          <div>
            <p className="text-xs text-muted-foreground">Y</p>
            <p className="text-lg font-medium tabular-nums">
              {data?.y ?? "--"}
            </p>
          </div>
          <div>
            <p className="text-xs text-muted-foreground">Z</p>
            <p className="text-lg font-medium tabular-nums">
              {data?.z ?? "--"}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
